/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: service_account.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateServiceAccountRequest,
  CreateServiceAccountResponse,
  DeleteServiceAccountRequest,
  DeleteServiceAccountResponse,
  GetServiceAccountRequest,
  GetServiceAccountResponse,
  ListServiceAccountsRequest,
  ListServiceAccountsResponse,
  RotateServiceAccountSecretRequest,
  RotateServiceAccountSecretResponse,
  UpdateServiceAccountRequest,
  UpdateServiceAccountResponse,
} from '../types/service_account';

export const createServiceAccountService = (transport: Transport) => ({
  async createServiceAccount(
    request: CreateServiceAccountRequest,
    options: RequestOptions = {},
  ): Promise<CreateServiceAccountResponse> {
    const url = getApiPath(API_METHODS.ServiceAccountService.CreateServiceAccount);
    return transport.post<CreateServiceAccountResponse>(url, request, options);
  },

  async listServiceAccounts(
    request: ListServiceAccountsRequest,
    options: RequestOptions = {},
  ): Promise<ListServiceAccountsResponse> {
    const url = getApiPath(API_METHODS.ServiceAccountService.ListServiceAccounts);
    return transport.get<ListServiceAccountsResponse>(url, { params: request, ...options });
  },

  async getServiceAccount(
    request: GetServiceAccountRequest,
    options: RequestOptions = {},
  ): Promise<GetServiceAccountResponse> {
    const { service_account_id } = request;
    const url = getApiPath(API_METHODS.ServiceAccountService.GetServiceAccount, {
      service_account_id,
    });
    return transport.get<GetServiceAccountResponse>(url, options);
  },

  async rotateServiceAccountSecret(
    request: RotateServiceAccountSecretRequest,
    options: RequestOptions = {},
  ): Promise<RotateServiceAccountSecretResponse> {
    const { service_account_id } = request;
    const url = getApiPath(API_METHODS.ServiceAccountService.RotateServiceAccountSecret, {
      service_account_id,
    });
    return transport.post<RotateServiceAccountSecretResponse>(url, {}, options);
  },

  async updateServiceAccount(
    request: UpdateServiceAccountRequest,
    options: RequestOptions = {},
  ): Promise<UpdateServiceAccountResponse> {
    const { service_account_id, ...body } = request;
    const url = getApiPath(API_METHODS.ServiceAccountService.UpdateServiceAccount, {
      service_account_id,
    });
    return transport.post<UpdateServiceAccountResponse>(url, body, options);
  },

  async deleteServiceAccount(
    request: DeleteServiceAccountRequest,
    options: RequestOptions = {},
  ): Promise<DeleteServiceAccountResponse> {
    const { service_account_id } = request;
    const url = getApiPath(API_METHODS.ServiceAccountService.DeleteServiceAccount, {
      service_account_id,
    });
    return transport.delete<DeleteServiceAccountResponse>(url, options);
  },
});

export type ServiceAccountService = ReturnType<typeof createServiceAccountService>;
